import { Step } from '../components/steps/Step';
import { OnboardingFlows } from './common';

export const seniority: Step = {
    id: OnboardingFlows.NewDepartment,
    title: `What department are you in?`,
    multiSelect: false,
    randomize: true,
    options: [
        {
            label: 'Marketing',
        },
        {
            label: 'Learning & Development',
        },
        {
            label: 'Sales',
        },
        {
            label: 'HR',
        },
        {
            label: 'Customer Support',
        },
        {
            label: 'Product Management',
        },
        {
            label: 'Freelancer, Content Creator',
        },
        {
            label: 'Customer Success',
        },
        {
            label: 'Academy, K-12, Teacher, Student',
        },
        {
            label: 'R&D (development, engineering)',
        },
        {
            label: 'Innovation',
        },
        {
            label: 'Other',
            id: 'onboard_new_department_other',
        },
    ],
};
